import { z } from 'zod';

import type { CreateCityRequestViewModel } from '@/shared/api/generated';

/**
 * Schema do formulário de Cidade (criar/editar). Validado por Zod (React Hook
 * Form + resolver).
 *
 * NÃO derivado de `createCityRequestViewModelSchema` (gerado pelo Kubb): aquele
 * schema é exportado com o cast `as unknown as ToZod<...>`, que degrada o
 * `z.infer` para `never`. Por isso é definido aqui, endurecendo `code` e `name`
 * como obrigatórios, `stateId` como número positivo e `population` como número
 * não-negativo opcional (o contrato gerado os tem como opcionais/nullish),
 * refletindo os campos `Código*`/`Nome*`/`Estado*`/`População` do protótipo
 * `design/location.pen`.
 */
export const cityFormSchema = z.object({
  code: z.string().trim().min(1),
  name: z.string().trim().min(1),
  stateId: z.number().int().positive(),
  population: z.number().int().nonnegative().optional(),
});

/**
 * Valores do formulário de Cidade (create/edit).
 *
 * O tipo intersecta com uma asserção nula (no-op) que só permanece `unknown`
 * enquanto `code | name | stateId | population` continuarem existindo em
 * `CreateCityRequestViewModel` — se um for renomeado/removido no contrato gerado
 * pelo Kubb, a asserção vira `never` e o `yarn type-check` quebra aqui.
 */
export type CityFormValues = z.infer<typeof cityFormSchema> &
  ('code' | 'name' | 'stateId' | 'population' extends keyof CreateCityRequestViewModel
    ? unknown
    : never);
